import {styled} from "@mui/material/styles";
import {Box, Paper} from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const ThumbnailImgWrapper = styled("div")(() => ({
    overflow: "hidden",
    position: "relative",
    zIndex: 1,
    borderRadius: "0.25rem",
    "&:hover img": {
        transform: "scale(1.2)",
    }
}));

/**
 * A styled img used to display gallery thumbnails
 */
const ThumbnailImg = styled("img")(() => ({
    aspectRatio: "1 / 1",
    cursor: "pointer",
    width: "100%",
    transition: "transform 1.5s ease",
    display:"flex",
}));

const ThumbnailContainer = styled(Paper)(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    width: "100%",
}));

const StyledThumbnail = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
    const { children, ...otherProps } = props;
    return <ThumbnailImgWrapper>
        { children }
        <ThumbnailImg {...otherProps} />
    </ThumbnailImgWrapper>;
}

interface ThumbnailProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    isVideo: boolean,
}

const Thumbnail = ({isVideo, ...otherProps}: ThumbnailProps) => {
    return <StyledThumbnail {...otherProps}>
        {isVideo && <Box onClick={otherProps.onClick} sx={{
            alignItems: "center",
            color: "rgba(255, 255, 255, 0.5)",
            cursor: "pointer",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            zIndex: 99999
        }}><PlayCircleOutlineIcon sx={{ fontSize: 80 }}/></Box>}
    </StyledThumbnail>
}

export {Thumbnail, ThumbnailContainer}